import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    titleContainer: {
        marginTop: 2,
    },
    reportTitle: {
        marginBottom: 3,
        color: '#3778C2',
        letterSpacing: 4,
        fontSize: 15,
        textAlign: 'center',
        textTransform: 'uppercase',
    },
    agentName: {
        color: '#ED0000',
        fontSize: 10,
        textAlign: 'center',
        textTransform: 'uppercase',
    }
});

const InvoiceTitle = ({ items }) => (
    <View style={styles.titleContainer}>
        <Text style={styles.reportTitle}>Invoice</Text>
        <Text style={styles.agentName}>{items.agentRegistration.companyName}</Text>
        <Text style={styles.agentName}>{items.agentRegistration.state.stateName}</Text>
        <Text style={styles.agentName}>{items.agentRegistration.mobileNumber}</Text>
        <Text style={styles.agentName}>PAN: {items.agentRegistration.panId}</Text>
        {items.agentRegistration.gst &&
            <Text style={styles.agentName}>GST: {items.agentRegistration.gst}</Text>
        }

    </View>
);

export default InvoiceTitle;
